import { getFormattedNumberedTimeWithoutZone } from 'studiokit-scaffolding-js/lib/utils/date'

/**
 * The share of the user's quota they have consumed, as a whole percentage.
 *
 * @param used Tokens consumed within the current window.
 * @param maxUserTokenCount The user's quota for the window.
 */
export function getUsedPercent(used: number, maxUserTokenCount: number) {
	if (maxUserTokenCount <= 0) {
		return 100
	}
	// the API refuses a user once they are *over* the limit, so `used` can exceed the quota
	return Math.min(100, Math.max(0, Math.round((used / maxUserTokenCount) * 100)))
}

/**
 * The local time the user will be allowed through again, e.g. `4:15 PM`, or `undefined` when they are
 * under the limit and there is nothing to wait for.
 *
 * @param resumesAt A UTC date time string, or `null`.
 */
export function formatResumesAt(resumesAt: string | null) {
	return resumesAt ? getFormattedNumberedTimeWithoutZone(resumesAt) : undefined
}
